export default "__VITE_ASSET__CGDa7xFd__"